'use client';
import CryptoJS from 'crypto-js';
import { getCookie } from 'eco-design-micro/utils-base/getCookie';

/** website_user 加签密钥（见 HTTP 报文签名方案） https://ecoflow.feishu.cn/wiki/Er0xwluSSi71VQknTUcc1t1xnjb*/
const WEB_SIGN_KEY = 'IdBw0t41aTy2VQKv';

const randomNonce = (length = 8) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

/**
 *  HTTP 报文加签 headers（通用，支持 GET/POST 等）
 *  仅适用于 bodyHash="null" 的场景（multipart/form-data / 无 body / 非 JSON POST）
 */
export const getSignHeaders = (method: string, url: string): Record<string, string> => {
    const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://dummy.local');
    const path = parsed.pathname;
    const queryEntries = Array.from(parsed.searchParams.entries());
    const seen = new Set<string>();
    const queryParts: string[] = [];
    for (const [key, value] of queryEntries.sort((a, b) => a[0].localeCompare(b[0]))) {
        const isArrayKey = key.endsWith('[]');
        if (!isArrayKey && seen.has(key)) continue;
        seen.add(key);
        queryParts.push(`${key}=${value}`);
    }
    const queryParams = queryParts.join('&');
    // multipart/form-data 或无 body → bodyHash 固定为 "null"
    const bodyHash = 'null';
    const timestamp = String(Date.now());
    const nonce = randomNonce(8);
    const msg = `${method.toUpperCase()}${path}${queryParams}${bodyHash}${timestamp}${nonce}`;
    const sign = CryptoJS.HmacSHA256(msg, WEB_SIGN_KEY).toString(CryptoJS.enc.Hex).toUpperCase();

    return {
        Platform: 'web',
        Version: '1.0.0',
        SystemName: 'website_user',
        'X-Timestamp': timestamp,
        'X-Nonce': nonce,
        'X-Sign': sign,
    };
};

/** 上传接口鉴权 headers */
export const getUploadAuthHeaders = (): Record<string, string> => {
    let token: string = '';
    const token1 = getCookie('token') || '';
    if (token1) {
        token = token1;
    } else {
        const userInfo: any = getCookie('userInfo');
        if (userInfo) {
            const token2 = JSON.parse(decodeURIComponent(getCookie('userInfo')) || '{userInfo:{token:""}}')?.token || '';
            if (token2) {
                token = token2;
            }
        }
    }
    if (token) {
        return { Authorization: `Bearer ${token}` };
    }
    return {};
};

export const supportedTypes = [
    'image/jpeg', // jpg
    'image/jpeg', // jpeg
    'image/png', // png
    'image/webp', // webp
    'image/svg+xml', // svg
    'image/gif', // gif
    'video/mp4', // mp4
    'video/webm', // webm
    'model/gltf-binary', // glb
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    'application/pdf', // pdf
    'application/msword', // doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
    'application/vnd.ms-excel', // xls
    'text/csv', // csv
    'application/vnd.ms-powerpoint', // ppt
];
